import axios from "axios";
import { getAxiosInstance } from "./axiosInstance";
import { toast } from "react-toastify";

const colors = ["orange", "red", "green", "purple", "blue", "yellow"];

const getRandomColor = () =>{
    const num = Math.floor(Math.random() * 3);
    return colors[num];
}

export type role = {
    value: string,
    label: string,
    colorScheme: string
 };

const getRolesArray = async (): Promise<any[]> => {
    let roles: role[] = [];
    try{
        const res = await getAxiosInstance().get('/role');
        let r = [...res.data];

        for(const c of r){
            roles.push({ value:c.role, label: c.role, colorScheme: getRandomColor() })
        }

        return roles;

    } catch(error) {
        if (axios.isAxiosError(error)) {
            toast.error(`${error.response?.data} error has occurred`, { position: toast.POSITION.BOTTOM_RIGHT })
          } else {
            toast.error(`Fields not filled out properly ${error}`, { position: toast.POSITION.BOTTOM_RIGHT });
          }
          return [];
    }
}

export default getRolesArray;